import { Button } from 'antd';
import styled, { css } from 'styled-components';

import Colors from '@rockalingua/ui/constants/Colors';
import MediaQueryBreakpoints from '@rockalingua/ui/constants/MediaQueryBreakpoints';
import { variantStyles as textVariantStyles } from '../Typography/Text.styled';

const typeStyles = {
  primary: css``,
  default: css`
    background-color: white;
  `,
  link: css`
    display: flex;
    padding: 4px 0 !important;
    height: auto !important;
  `,
} as const;

const colorStyles = {
  danger: css`
    color: ${Colors.ERROR_VARIANTS[50]};
  `,
  accent: css`
    color: ${Colors.WHITE} !important;
    background-color: ${Colors.ACCENT_VARIANTS[90]};
    border-color: ${Colors.ACCENT_VARIANTS[90]};

    &:hover,
    &:focus {
      background-color: ${Colors.ACCENT_VARIANTS[70]};
      border-color: ${Colors.ACCENT_VARIANTS[90]};
    }
  `,
  purple: css``,
} as const;

export type ButtonColor = keyof typeof colorStyles;

export const buttonSizeStyles = {
  large: css`
    padding: 14px 48px;
    height: 48px;
    line-height: 20px !important;

    @media (${MediaQueryBreakpoints.isUltraWide}) {
      padding: 10px 35px;
      height: 40px;
      line-height: 10px !important;
    }
  `,
  small: css`
    font-size: 14px;
    border-radius: 24px;
    line-height: 18px;
    padding: 8px 24px;
    height: 40px;
  `,
  ['x-small']: css`
    font-size: 14px;
    border-radius: 24px;
    line-height: 18px;
    padding: 8px 18px;
    height: 32px;
    display: flex;
    align-items: center;
  `,
} as const;

export type ButtonSize = keyof typeof buttonSizeStyles;

type StyledButtonProps = {
  $color?: ButtonColor;
};

export const StyledButton = styled(Button)<StyledButtonProps>`
  ${textVariantStyles['dm-16-medium']}

  ${({ size }) =>
    size &&
    size in buttonSizeStyles &&
    buttonSizeStyles[size as keyof typeof buttonSizeStyles]}

  ${({ $color }) =>
    $color && colorStyles[$color] ? colorStyles[$color] : null}

  ${({ type }) =>
    type && type in typeStyles && typeStyles[type as keyof typeof typeStyles]}

  .button-icon + span {
    margin-left: 8px;
  }
`;
